import { createContext, useContext } from "react";

export const defaultWalletAuthValue = Object.freeze({
  authBusy: false,
  authError: "",
  canLogout: false,
  connectAndAuthenticate: async () => null,
  connectors: [],
  disconnectAndLogout: async () => {},
  embeddedStatus: "idle",
  phantomEmbeddedStatus: "idle",
  isAuthenticated: false,
  loadWalletRuntime: async () => {},
  loadingSession: true,
  refreshSession: async () => null,
  session: null,
  signingMode: "sign-only",
  status: "idle",
  wallet: null,
  walletCanSignTransaction: false,
  walletError: "",
  walletReady: false,
  walletRuntimeLoaded: false,
  walletRuntimeLoading: false,
  walletSupportMessage: ""
});

export const WalletAuthContext = createContext(null);

export function useWalletAuth() {
  const context = useContext(WalletAuthContext);
  if (!context) {
    throw new Error("useWalletAuth must be used inside WalletAuthProvider.");
  }
  return context;
}
